import React, { useContext, useEffect } from "react";
import { useHistory } from "react-router-dom";
import Menu from "@components/Menu";
import UserContext from '@components/context/userContext';

import {
  MdReceipt,
  MdKeyboardReturn,
  MdOutlineRequestQuote,
  MdOutlineSwitchLeft,
} from "react-icons/md";

import "./type.css";

const documentTypes = [
  {
    id: "quotes",
    title: "Encomenda",
    description: "Efetuar uma encomenda a fornecedor",
    icon: <MdReceipt />,
    color: "bg-success",
    bgColor: "#5bc0de",
  },
  {
    id: "orders",
    title: "Compra",
    description: "Emitir uma compra a fornecedor",
    icon: <MdOutlineRequestQuote />,
    color: "bg-primary",
    bgColor: "#337ab7",
  },
  {
    id: "returns",
    title: "Devolução",
    description: "Emitir uma devolução a fornecedor",
    icon: <MdKeyboardReturn />,
    color: "bg-info",
    bgColor: "#d9534f",
  },
  {
    id: "transfer",
    title: "Transferência",
    description: "Efetuar uma transferência de stock",
    icon: <MdOutlineSwitchLeft />,
    color: "bg-success",
    bgColor: "#5cb85c",
  },
];

function App() {
  const profile = useContext(UserContext);
  const history = useHistory();

  const handleSelectDocument = (docType) => {
    history.push("/orders/new/" + docType.id);
  };

  return (
    <div>
      <Menu />
      <div className="fullContainer" style={{ maxWidth: "100%" }}>
        <div className="col-xs-12">
          <ol
            style={{
              textAlign: "left",
              marginTop: "75px",
            }}
            className="breadcrumb"
          >
            <li>
              <a href="http://eposgestofinal.com/index.php">Portal</a>
            </li>
            <li>
              <a href="/orders">Compras</a>
            </li>
            <li className="active">
              <span>Novo Documento</span>
            </li>
          </ol>
        </div>
      </div>
      <div className="fullContainer sales-type">
        <div className="row">
          <div className="col-xs-12 text-center">
            <h1 className="page-header">Documentos de Compras</h1>
            <p className="lead">
              Selecione o tipo de documento que deseja criar
            </p>
          </div>
        </div>

        <div className="row">
          {documentTypes.map((docType) => (
            <div key={docType.id} className="col-sm-6 col-md-4">
              <div
                className={`panel panel-default document-card ${
                  docType.comingSoon ? "disabled" : ""
                }`}
                onClick={() => handleSelectDocument(docType)}
                style={{
                  cursor: docType.comingSoon ? "not-allowed" : "pointer",
                  opacity: docType.comingSoon ? 0.5 : 1,
                }}
              >
                <div className="panel-body">
                  <div className="media">
                    <div className="media-left">
                      <div
                        className="icon-container"
                        style={{ backgroundColor: docType.bgColor }}
                      >
                        {docType.icon}
                      </div>
                    </div>
                    <div className="media-body">
                      <h4 className="media-heading">
                        {docType.title}
                        {docType.comingSoon && (
                          <small className="text-muted"> (Brevemente)</small>
                        )}
                      </h4>
                      <p>{docType.description}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default App;
